var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "all_nav" },
    [
      _c(
        "div",
        { staticClass: "top_search" },
        [
          _c("el-input", {
            staticClass: "nav_search",
            attrs: {
              placeholder: "请输入关键字",
              "prefix-icon": "el-icon-search",
              size: "small"
            },
            model: {
              value: _vm.filterText,
              callback: function($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText"
            }
          }),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              attrs: { trigger: "click" },
              on: { command: _vm.handleCommandConfig }
            },
            [
              _c("span", { staticClass: "config_nav" }, [
                _vm._v("\n        一键配置"),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.presetConfigList, function(item) {
                  return _c(
                    "el-dropdown-item",
                    { key: item.id, attrs: { command: item } },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav_main" },
        _vm._l(_vm.treeData, function(item) {
          return _c(
            "div",
            { key: item.id, staticClass: "nav_item" },
            [
              _c(
                "p",
                [
                  _c("i", { staticClass: "el-icon-house" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(item.name) +
                        _vm._s(
                          _vm.$store.state.nav.currentPlatform[item.id]
                            .currentShopName != ""
                            ? "-" +
                                _vm.$store.state.nav.currentPlatform[item.id]
                                  .currentShopName
                            : ""
                        )
                    )
                  ]),
                  _vm._v(" "),
                  item.shops.length > 0
                    ? _c(
                        "el-dropdown",
                        {
                          attrs: { trigger: "click" },
                          on: { command: _vm.handleCommand }
                        },
                        [
                          _c("i", { staticClass: "el-icon-caret-bottom" }),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            _vm._l(item.shops, function(shopItem) {
                              return _c(
                                "el-dropdown-item",
                                {
                                  key: shopItem.platformShopId,
                                  attrs: {
                                    command: {
                                      shopInfo: shopItem,
                                      platformId: item.id
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(shopItem.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "tree",
                refInFor: true,
                staticClass: "nav_item_tree",
                attrs: {
                  data: item.menus,
                  "default-expand-all": "",
                  "node-key": "id",
                  props: _vm.navDefaultProps,
                  "filter-node-method": _vm.filterNode
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var data = ref.data
                        return _c(
                          "span",
                          {
                            staticClass: "custom-tree-node",
                            on: {
                              click: function($event) {
                                return _vm.goLocation(item, data)
                              }
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(data.name))]),
                            _vm._v(" "),
                            data.config.route
                              ? [
                                  data.hasCollected
                                    ? _c("i", {
                                        staticClass: "el-icon-star-on",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.delNav(item, data)
                                          }
                                        }
                                      })
                                    : _c("i", {
                                        staticClass: "el-icon-star-off",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.editNavName(item, data)
                                          }
                                        }
                                      })
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("edit-nav-alias", {
        attrs: { "nav-config": _vm.navConfig, "show-edit": _vm.showEditBox },
        on: { handleCancle: _vm.handleCancel, handleConfirm: _vm.handleConfirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e797ee6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e797ee6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/all-nav/index.vue
// module id = null
// module chunks = 